import { ca } from '@cian/analytics';
import { EPageBlock, ILastChanceDiscountBlockPageExtra } from '../../../types/analytics';
import { IPage } from '../../../types/redux';

type TAction = 'show_sopr' | 'Click';

export function trackLastChanceDiscount(action: TAction, page: IPage) {
  const pageExtra: ILastChanceDiscountBlockPageExtra = {
    block: EPageBlock.PromoEnding,
  };

  return ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action,
    label: 'Block',
    page: {
      ...page,
      extra: pageExtra,
    },
  });
}
